import { isProduction } from './constantes'

export const PAGE_TITLE_SUFFIX = 'Planning – The Game'

export const buildPageTitle = (title) => {
  const pageTitle = title?.trim() || ''
  const environmentTitle = isProduction ? pageTitle : `DEV - ${pageTitle}`

  return `${environmentTitle}${title ? ' |\u00a0' : ''}${PAGE_TITLE_SUFFIX}`
}

export const setPageTitle = (title) => {
  document.title = buildPageTitle(title)
}
